import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.isFeatured);
  const hotArticles = articles.filter((a) => a.isHot && !a.isFeatured);
  const latestArticles = articles.filter((a) => !a.isFeatured && !a.isHot).slice(0, 6);

  const featuredMain = featuredArticles[0];
  const featuredSide = featuredArticles.slice(1, 4);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51吃瓜网',
    url: 'https://51chigua.example.com',
    description: '51吃瓜网今日吃瓜资源聚焦台北娜娜、莫里秀、玩偶姐姐等热门网红人物，提供人物合集、最新系列专题与网红动态盘点，满足粉丝关注。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://51chigua.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/* Hero Section */}
      <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20entertainment%20news%20media%20studio%20with%20multiple%20digital%20screens%20displaying%20social%20media%20content%2C%20warm%20lighting%2C%20professional%20broadcast%20setting%2C%20clean%20minimalist%20aesthetic%2C%20creative%20workspace%2C%20cinematic%20atmosphere&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="51吃瓜网 - 最新网红资讯"
          className="w-full h-full object-cover"
          title="51吃瓜网 - 最新网红资讯平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading animate-fade-in-up">
            51吃瓜网
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            聚焦台北娜娜、莫里秀、玩偶姐姐等热门网红人物，提供人物合集、最新系列专题与网红动态盘点
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <Link
              to="/category/wanghong-dongtai"
              className="px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览最新动态
            </Link>
            <Link
              to="/category/renwu-zhuanji"
              className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-semibold hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看人物合集
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                精选推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">编辑精选的优质内容</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {featuredMain && (
            <div className="mb-6">
              <ArticleCard article={featuredMain} variant="featured" />
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {featuredSide.map((article) => (
              <ArticleCard key={article.id} article={article} variant="default" />
            ))}
          </div>
        </div>
      </section>

      {/* Hot Articles */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
              <i className="ri-fire-line text-background-50 dark:text-foreground-950"></i>
            </div>
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                热门八卦
              </h2>
              <p className="text-sm text-foreground-500 mt-1">全网最火的网红话题</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {hotArticles.slice(0, 6).map((article) => (
              <ArticleCard key={article.id} article={article} variant="default" />
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                最新资讯
              </h2>
              <p className="text-sm text-foreground-500 mt-1">持续更新的网红动态</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} variant="default" />
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              加载更多内容 <i className="ri-arrow-down-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="w-full px-4 md:px-6 py-16 bg-primary-500">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 dark:text-foreground-950 mb-3 font-heading">
            不想错过任何瓜？
          </h2>
          <p className="text-base text-background-50/80 dark:text-foreground-950/80 mb-6">
            订阅51吃瓜网，第一时间获取最新网红动态和独家八卦
          </p>
          <form
            data-readdy-form
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              const altField = formData.get('phone_alt');
              if (altField && String(altField).trim() !== '') {
                const msg = document.getElementById('newsletter-msg');
                if (msg) { msg.textContent = '订阅成功！感谢您的关注'; msg.className = 'text-sm text-green-200 mt-3 animate-fade-in'; }
                form.reset();
                return;
              }
              try {
                const res = await fetch('https://readdy.ai/api/form/d9oqoeaftmtnfcfh0cg0', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: new URLSearchParams(new FormData(form) as unknown as Record<string, string>).toString(),
                });
                const text = await res.text();
                const msg = document.getElementById('newsletter-msg');
                if (msg) {
                  try {
                    const parsed = JSON.parse(text);
                    if (res.ok && parsed?.code === 'OK') {
                      msg.textContent = '订阅成功！感谢您的关注';
                      msg.className = 'text-sm text-green-200 mt-3 animate-fade-in';
                      form.reset();
                    } else {
                      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
                      msg.textContent = serverMsg.includes('spam') ? '订阅失败，请稍后重试' : (serverMsg || '订阅失败，请稍后重试');
                      msg.className = 'text-sm text-red-200 mt-3 animate-fade-in';
                    }
                  } catch {
                    msg.textContent = '订阅失败，请稍后重试';
                    msg.className = 'text-sm text-red-200 mt-3 animate-fade-in';
                  }
                }
              } catch {
                const msg = document.getElementById('newsletter-msg');
                if (msg) { msg.textContent = '订阅失败，请稍后重试'; msg.className = 'text-sm text-red-200 mt-3 animate-fade-in'; }
              }
            }}
          >
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 w-full px-4 py-3 rounded-full text-sm text-foreground-900 bg-background-50 border-0 focus:outline-none focus:ring-2 focus:ring-background-300"
            />
            <div className="field-website-alt-wrap">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即订阅
            </button>
          </form>
          <div id="newsletter-msg"></div>
        </div>
      </section>
    </>
  );
}